// @ts-nocheck
import { Course } from '@yandex-int/k-common/typings/index';
import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import ClosingLessonModal from 'common.components/closing-lesson-modal/closing-lesson-modal';
import { SEARCH_PARAMS_INTEGRATION } from 'common.components/constants';
import { actions as lessonActions } from 'common.components/lesson';
import LessonView from 'common.components/lesson-view.index/lesson-view';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { actions as coursesActions } from 'store/courses/actions';

import { ReduxTeacherStore, RootAction } from '../../typings';

interface HOCProps extends WithRouterPathHOC {}

interface StoreProps {
    courseId: number | null;
}

interface DispatchProps {
    getClessonWithResultsRequest: typeof lessonActions.getClessonWithResultsRequest;
    getCoursesByTeamRequest: typeof coursesActions.getCoursesByTeamRequest;
    getCoursesByTeamSuccess: typeof coursesActions.getCoursesByTeamSuccess;
    toggleLessonModal: typeof lessonViewActions.toggleModal;
}

interface Props extends HOCProps, StoreProps, DispatchProps {}

interface Context {
    data: {
        getCourses?: Array<Course>;
    };
    initialRender: boolean;
}

const LessonSandbox = (props: Props, context: Context) => {
    useEffect(() => {
        const {
            courseId,
            getClessonWithResultsRequest,
            getCoursesByTeamRequest,
            getCoursesByTeamSuccess,
            match: {
                params: { classId, clessonId },
            },
            toggleLessonModal,
        } = props;
        const { initialRender, data } = context;

        const teamId = Number(classId);

        if (initialRender && data.getCourses) {
            getCoursesByTeamSuccess({ teamId, courses: data.getCourses });
        } else if (teamId) {
            if (typeof window !== 'undefined') {
                getCoursesByTeamRequest({ teamId });
            }
        }

        if (typeof window !== 'undefined') {
            getClessonWithResultsRequest({
                courseId: Number(courseId),
                clessonId: Number(clessonId),
                onSuccess: () => toggleLessonModal(true),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const backUrlRedirect = () => {
        const {
            location: { search },
        } = props;

        const searchParams = qs.parse(search);
        const { [SEARCH_PARAMS_INTEGRATION.BACK_URL]: backUrl } = searchParams;

        window.location.href = decodeURIComponent(backUrl);
    };

    return (
        <>
            <LessonView
                isCopyingEnabled={false}
                isPutOnBoardEnabled={false}
                onClose={backUrlRedirect}
                onForceComplete={backUrlRedirect}
                shouldShowResultsStub={true}
            />
            <ClosingLessonModal />
        </>
    );
};

const mapStateToProps = (storeState: ReduxTeacherStore): StoreProps => ({
    courseId: lessonSelectors.getLessonOrCurrentYearCourseId(storeState),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    return bindActionCreators(
        {
            getClessonWithResultsRequest: lessonActions.getClessonWithResultsRequest,
            getCoursesByTeamRequest: coursesActions.getCoursesByTeamRequest,
            getCoursesByTeamSuccess: coursesActions.getCoursesByTeamSuccess,
            toggleLessonModal: lessonViewActions.toggleModal,
        },
        dispatch
    );
};

LessonSandbox.contextTypes = {
    data: PropTypes.object,
    initialRender: PropTypes.bool.isRequired,
};

export default withRouterPath(connect(mapStateToProps, mapDispatchToProps)(LessonSandbox));
